module.exports = __webpack_public_path__ + "static/media/profile-picture.6732bd42.png";